import React from "react";
import styled from "styled-components";

export default styled.div`
    
    max-height: 344px;
    overflow-y: scroll;
    border: 1px solid #979797;
    margin-bottom: 25px;
`;